import { render, staticRenderFns } from "./PagePromos.vue?vue&type=template&id=7eece12e&"
import script from "./PagePromos.vue?vue&type=script&lang=js&"
export * from "./PagePromos.vue?vue&type=script&lang=js&"
import style0 from "./PagePromos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports